
import { defineComponent } from 'vue'
import { iWord } from '../GlossaryDefinition'
import { createValidations } from '@/helpers/commons/validationHelper'
import { AxiosResponse } from 'axios'
import Dialog from 'primevue/dialog'
import Dropdown from 'primevue/dropdown'
import AutoComplete from 'primevue/autocomplete'
//import AttributesTable from './tables/GlossaryDefinitionAttributesTable.vue'
import glossaryDefinitionDialogDescriptor from './GlossaryDefinitionDialogDescriptor.json'
import glossaryDefinitionDescriptor from '../GlossaryDefinitionDescriptor.json'
import glossaryDefinitionDialogValidationDescriptor from './GlossaryDefinitionDialogValidationDescriptor.json'
import useValidate from '@vuelidate/core'
import KnValidationMessages from '@/components/UI/KnValidatonMessages.vue'
export default defineComponent({
    name: 'edit-word',
    components: {
        Dialog,
        Dropdown,
        AutoComplete,
        KnValidationMessages
        //AttributesTable
    },
    props: {
        visible: {
            type: Boolean,
            required: true
        },
        propWord: {
            type: Object,
            required: false
        },
        state: {
            type: Array,
            required: true
        },
        category: {
            type: Array,
            required: true
        },
        selectedGlossaryId: {
            type: Number
        }
    },
    emits: ['close', 'saved', 'reloadTree'],
    data() {
        return {
            glossaryDefinitionDialogDescriptor,
            glossaryDefinitionDialogValidationDescriptor,
            glossaryDefinitionDescriptor,
            word: {} as iWord,
            tState: [] as any,
            tCategory: [] as any,
            oldWordName: null as any,
            filteredWords: [] as iWord[],
            operation: 'insert',
            v$: useValidate() as any
        }
    },
    computed: {
        buttonDisabled(): any {
            return this.v$.$invalid
        },
        availableWords(): any {
            if (this.word && this.word.LINK) {
                return this.filteredWords.filter((word: iWord) => this.word && this.word.LINK && this.word.LINK.findIndex((link: any) => word.WORD_ID === link.WORD_ID) < 0)
            }
            return this.filteredWords
        }
    },
    validations() {
        const validationObject = {
            word: createValidations('word', glossaryDefinitionDialogValidationDescriptor.validations.word)
        }
        return validationObject
    },
    watch: {
        propWord() {
            this.v$.$reset()
            this.word = { ...this.propWord } as iWord
            this.oldWordName = this.word.WORD
        },
        state() {
            this.tState = this.state.map((s: any) => {
                return {
                    id: s.VALUE_ID,
                    name: this.$t(glossaryDefinitionDescriptor.translation[s.VALUE_NM])
                }
            })
        },
        category() {
            this.tCategory = this.category.map((c: any) => {
                return {
                    id: c.VALUE_ID,
                    name: this.$t(glossaryDefinitionDescriptor.translation[c.VALUE_NM])
                }
            })
        }
    },
    mounted() {
        if (this.propWord) {
            this.word = { ...this.propWord } as iWord
            this.oldWordName = this.word.WORD
        }
        this.tState = this.state.map((s: any) => {
            return {
                id: s.VALUE_ID,
                name: this.$t(glossaryDefinitionDescriptor.translation[s.VALUE_NM])
            }
        })
        this.tCategory = this.state.map((c: any) => {
            return {
                id: c.VALUE_ID,
                name: this.$t(glossaryDefinitionDescriptor.translation[c.VALUE_NM])
            }
        })
    },
    methods: {
        async saveWord() {
            if (this.word?.WORD_ID) {
                this.operation = 'update'
                this.word.oldWord = { WORD_ID: this.word.WORD_ID, WORD: this.oldWordName }
                this.word.SaveOrUpdate = 'Update'
            } else {
                this.operation = 'insert'
                this.word.NEWWORD = true
                this.word.SaveOrUpdate = 'Save'
            }

            await this.$http
                .post(process.env.VUE_APP_RESTFUL_SERVICES_PATH + '1.0/glossary/business/addWord', this.word)
                .then((response: AxiosResponse<any>) => {
                    this.$emit('saved')
                    if (this.word.PARENT) {
                        this.saveContent(response.data.id)
                    }
                    this.$store.commit('setInfo', {
                        title: this.$t(this.glossaryDefinitionDialogDescriptor.operation[this.operation].toastTitle),
                        msg: this.$t(this.glossaryDefinitionDialogDescriptor.operation.success)
                    })
                })
                .catch((error) => {
                    this.$store.commit('setError', {
                        title: this.$t('managers.constraintManagment.saveError'),
                        msg: error.message
                    })
                })
        },
        closeDialog() {
            this.$emit('close')
        },
        async loadWords(word: string) {
            this.$http.get(process.env.VUE_APP_RESTFUL_SERVICES_PATH + `1.0/glossary/listWords?WORD=` + word).then((response: AxiosResponse<any>) => (this.filteredWords = response.data))
        },
        searchWord(event) {
            this.loadWords(event.query)
        },
        async saveContent(wordId: number) {
            await this.$http
                .post(process.env.VUE_APP_RESTFUL_SERVICES_PATH + '1.0/glossary/business/addContents', { GLOSSARY_ID: this.selectedGlossaryId, PARENT_ID: this.word.PARENT.CONTENT_ID, WORD_ID: wordId })
                .then((response: AxiosResponse<any>) => {
                    if (response.data.Status !== 'NON OK') {
                        this.$emit('reloadTree')
                    } else {
                        this.$store.commit('setError', {
                            title: this.$t('common.error.generic'),
                            msg: this.$t(this.glossaryDefinitionDescriptor.translation[response.data.Message])
                        })
                    }
                })
                .catch((response: AxiosResponse<any>) => {
                    this.$store.commit('setError', {
                        title: this.$t('common.error.generic'),
                        msg: response
                    })
                })
        }
    }
})
